import {createRoot} from 'react-dom/client'

const rootsByContainer = new WeakMap()

export const mountReactNode = (node, container) => {
  if (!container)
    return

  let root = rootsByContainer.get(container)

  if (!root) {
    root = createRoot(container)
    rootsByContainer.set(container, root)
  }

  root.render(node)
}

export const unmountReactNode = (container) => {
  if (!container)
    return

  const root = rootsByContainer.get(container)

  if (root) {
    root.unmount()
    rootsByContainer.delete(container)
  }
}
